import { render, staticRenderFns } from "./SpeedingWarningList.vue?vue&type=template&id=4a2edb1a"
import script from "./SpeedingWarningList.vue?vue&type=script&lang=js"
export * from "./SpeedingWarningList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports